import createClient from '@/clients/api'

export const buildThinkificUrl = async (returnTo) => {
  const client = await createClient()
  const res = await client.get(`/bottithek${returnTo ? '?returnTo=' + returnTo : ''}`)
  return res.data.text()
}
